import { RouteObject } from "react-router-dom";
import { CreateProfessionalProfile } from "../features/professional-profile/pages/create.page";
import { ViewProfessionalProfile } from "../features/professional-profile/pages/view.page";
import { WithAuth } from "../components/layout/with-auth/with-auth.component";

export const professionalProfilesRoutes: RouteObject[] = [
  {
    path: "/p",
    element: (
      <WithAuth>
        <ViewProfessionalProfile />
      </WithAuth>
    ),
  },
  {
    path: "/p/create",
    element: (
      <WithAuth>
        <CreateProfessionalProfile />
      </WithAuth>
    ),
  },
  {
    path: "/p/edit",
    element: (
      <WithAuth>
        <CreateProfessionalProfile editing />
      </WithAuth>
    ),
  },
  {
    path: "/p/:customURL",
    element: <ViewProfessionalProfile />,
  },
];
